// ------------------------------------------------------------------------------
// name: useWorkStyles - 作品风格数据集
// author: mudas
// created: 2024/12/5
// ------------------------------------------------------------------------------

import { useRequest } from 'ahooks';
import service from 'common/service';

export const useWorkStyles = () => {
  return useRequest(
    async () => {
      try {
        const response = await service.workV2.getWorkStyleList();
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    {
      cacheKey: 'getWorkStyleDimensionList',
      cacheTime: 300000, // 默认5分钟内不发起新的请求，直接使用缓存
    },
  );
};
